import axiosInstanceMicrosite from "./axiosInstanceMicrosite";

export const getCampaignCustomFields = async (campaignId) => {
  const { data } = await axiosInstanceMicrosite.get(`/campaigns/${campaignId}/custom_fields`);
  return data;
};

export const getNestedCampaignCustomField = async (campaignId, customFieldId) => {
  const { data } = await axiosInstanceMicrosite.get(
    `/campaigns/${campaignId}/custom_fields/${customFieldId}`,
  );
  return data;
};
